import React from "react";
import { useDropzone } from "react-dropzone";
import { Box, FormHelperText, IconButton } from "@mui/material";
import { DeleteForever } from "@mui/icons-material";
import { BASE_CONSTANTS } from "../../constants/baseConstants";

const FileDropzone = ({
  files,
  multiple = false,
  onFileChange = () => {},
  maxFiles = 10,
  maxFileSizeInMB = 5,
  error = false,
  helperText = "",
  disabled=false,
}) => {
  const [fileErrors, setFileErrors] = React.useState([]);

  const BYTES_TO_MB = 1048576;

  const filesLimit = multiple ? maxFiles : 1;

  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    maxFiles: filesLimit,
    maxSize: maxFileSizeInMB * BYTES_TO_MB, // in MB
    disabled,
    onDrop: (acceptedFiles) => {
      setFileErrors([]);
      onFileChange([...(multiple ? [...files] : []), ...acceptedFiles]);
    },
    onDropRejected: (error) => {
      const _mappedErrors = error?.map((e) => ({
        fileName: e.file.name,
        error: e.errors[0].message,
      }));

      setFileErrors(_mappedErrors);
    },
  });

  // methods
  const handleRemoveFile = (index) => {
    files.splice(index, 1);
    onFileChange(files);
  };

  return (
    <div className="grid grid-cols-1 gap-2">
      <div
        {...getRootProps({ className: "dropzone" })}
        className="grid h-28 grid-cols-1 place-content-center rounded border-2 border-dashed bg-gray-50 p-4 text-center dark:bg-slate-800"
      >
        <input {...getInputProps()} className="hidden" disabled={disabled} />

 <div>
          {disabled
            ? "File upload is disabled"
            : "Drag 'n' drop some files here, or click to select files"}
        </div>
      </div>      

      {helperText && (
        <Box paddingX={BASE_CONSTANTS.SPACING_SM}>
          <FormHelperText {...{ error }}>{helperText}</FormHelperText>
        </Box>
      )}

      <div className="text-sm text-gray-500 dark:text-gray-200">
        {multiple && (
          <span className="text-xs"> Max files: {filesLimit}, </span>
        )}
        <span className="text-xs"> Max size/file: {maxFileSizeInMB}MB</span>
      </div>

      <div>
        {!!files?.length && (
          <ul>
            {files?.map((file, index) => (
              <li key={file?.name + index}>
                <div className="flex items-center gap-2">
                  <div className="text-sm text-green-500 line-clamp-1 dark:text-green-200">
                    {file.name} - {(file.size / BYTES_TO_MB).toFixed(2)} MB.
                  </div>

                  <IconButton
                    size="small"
                    onClick={() => handleRemoveFile(index)}
                    disabled={disabled}
                  >
                    <DeleteForever
                      fontSize="small"
                      color="error"
                      className="flex-shrink-0"
                      disabled={disabled}
                    />
                  </IconButton>
                </div>
              </li>
            ))}
          </ul>
        )}

        {!!fileErrors?.length && (
          <ul>
            {fileErrors?.map((fe, index) => (
              <li
                key={fe?.fileName + index}
                className="text-red-500 dark:text-red-200"
              >
                <div className="text-sm">
                  <span>{fe?.fileName}</span> - <span> {fe?.error} </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FileDropzone;
